export const setAUMDataAgainstScheme=(data)=>{
    return {
        type: "SET_AUM_DATA_AGAINST_SCHEME",
        info: data,
    }
}
export const nullAUMDataAgainstScheme=()=>{
    return{
        type:"NULL_AUM_DATA_AGAINST_SCHEME",
        info: null
    }
}
export const getAUMDataAgainstScheme=()=>{
    return {
        type: "GET_AUM_DATA_AGAINST_SCHEME",
        
    }
}
